import ScreenLoader from './ScreenLoader';

export type {IScreenLoaderProps} from './shared';
export default ScreenLoader;
